import React, { Component } from 'react';
import golbeldata from '../data.json';
import Appnav from './Appnav.js'
import AppFooter from './Footer.js'
import AppTopHeader from './AppTopHeader.js'
import { Link, Route, Switch } from 'react-router-dom';

class Contact extends Component {
    constructor(props) {
        super(props);

        this.concerts = golbeldata;
    }

    componentDidMount() {
        document.title = this.concerts.HotelName+" Contact";
        //concerts: golbeldata
    }

    render() {
        console.log(this.concerts.HotelName);
        return (
            <div>
                <AppTopHeader data={this.concerts} />
                <header>
                    <Appnav data={this.concerts} />
                </header>
                <section class="parallax-effect">
                    <div id="parallax-pagetitle" style={{ backgroundImage: 'url("images/parallax/' + this.concerts.parllex + '")' }}>
                        <div class="color-overlay">

                            <div class="container">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <ol class="breadcrumb">
                                            <li><a href="index.html">Home</a></li>
                                            <li class="active">Explore</li>
                                        </ol>
                                        <h1>Explore</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div class="container">
                    <div class="row">
                        <section class="contact-details">
                            <div class="col-md-5">
                                <h2 class="lined-heading  mt50"><span>Address</span></h2>

                                <div class="panel panel-default text-center">
                                    <div class="panel-heading">
                                        <div class="panel-title"><i class="fa fa-star"></i> <strong>{this.concerts.HotelName}</strong></div>
                                    </div>
                                    <div class="panel-body">
                                        <address>
                                            <strong>{this.concerts.HotelName}</strong><br />
                                            {this.concerts.addressline1}<br />
                                            {this.concerts.addressline2}<br />
                                            <abbr title="Phone">P:</abbr> <a href="#">{this.concerts.phone}</a><br />
                                            <abbr title="Email">E:</abbr> <a href="#">{this.concerts.Email}</a><br />
                                            <abbr title="Website">W:</abbr> <a href="#">{this.concerts.Webiste}</a><br />
                                        </address>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section id="contact-form" class="mt50">
                            <div class="col-md-7">
                                <h2 class="lined-heading"><span>Send a message</span></h2>

                                <div id="message"></div>

                                <form class="clearfix mt50" role="form" method="post" action="php/contact.php" name="contactform" id="contactform">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="name" accesskey="U"><span class="required">*</span> Your Name</label>
                                                <input name="name" type="text" id="name" class="form-control" value="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="email" accesskey="E"><span class="required">*</span> E-mail</label>
                                                <input name="email" type="text" id="email" value="" class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="subject" accesskey="S">Subject</label>
                                        <select name="subject" id="subject" class="form-control">
                                            <option value="Booking">Booking</option>
                                            <option value="a Room">Room</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="comments" accesskey="C"><span class="required">*</span> Your message</label>
                                        <textarea name="comments" rows="9" id="comments" class="form-control"></textarea>
                                    </div>
                                    <button type="submit" class="btn  btn-lg btn-primary">Send message</button>
                                </form>
                            </div>
                        </section>
                    </div>
                </div>
                <AppFooter data={this.concerts} />
                <div id="go-top"><i class="fa fa-angle-up fa-2x"></i></div>

            </div>
        )
    }
}
export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js